import { graphql } from 'client/app/gql';

export const QUERY_DISCO_DEVICE_CONFIGS = graphql(/* GraphQL */ `
  query DiscoDeviceConfigs {
    discoDeviceConfigs {
      id
      description
    }
  }
`);
